module.exports = __webpack_public_path__ + "static/media/whitepaper2.73dc8148.png";